<template>
    <app-layout title="Organisasi Pengadaan">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>
        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-5 mx-auto">
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <Accordion :multiple="true" :activeIndex="[0, 1, 2, 3, 4, 5]">
                                    <AccordionTab>
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Paket Pengadaan</span>
                                            </span>
                                        </template>
                                        <InputText 
                                            class="w-3/4" 
                                            id="organisasi_pengadaan" 
                                            type="hidden"
                                            :class="{'p-invalid' : errors.organisasi_pengadaan}" 
                                            v-model="form.organisasi_pengadaan_id"
                                        />
                                        <InputText 
                                            class="w-3/4" 
                                            id="paket_pengadaan" 
                                            type="hidden"
                                            :class="{'p-invalid' : errors.paket_pengadaan}" 
                                            v-model="form.paket_pengadaan_id"
                                        />
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="nama_paket_pengadaan" value="Nama Paket Pengadaan" />
                                                <InputText 
                                                    class="w-3/4" 
                                                    id="nama_paket_pengadaan" 
                                                    type="text" 
                                                    disabled="true"
                                                    :class="{'p-invalid' : errors.nama_paket_pengadaan}" 
                                                    :value="initialform.paket_pengadaan.nama_paket_pengadaan"
                                                />
                                            </div>
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="pagu_anggaran" value="Pagu Anggaran" />
                                                <InputText 
                                                    class="w-3/4" 
                                                    id="pagu_anggaran" 
                                                    type="text"  
                                                    disabled="true"
                                                    :class="{'p-invalid' : errors.pagu_anggaran}" 
                                                    :value="initialform.paket_pengadaan.pagu_anggaran"
                                                />
                                            </div>
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="jenis_pengadaan" value="Jenis Pekerjaan" />
                                                <InputText 
                                                    class="w-3/4" 
                                                    id="jenis_pengadaan" 
                                                    type="text"  
                                                    disabled="true"
                                                    :class="{'p-invalid' : errors.jenis_pengadaan}" 
                                                    :value="initialform.paket_pengadaan.nama_pekerjaan"
                                                />
                                            </div>
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="spesifikasi_pekerjaan" value="Spesifikasi Pekerjaan" />
                                                <InputText 
                                                    class="w-3/4" 
                                                    id="spesifikasi_pekerjaan" 
                                                    type="text"  
                                                    disabled="true"
                                                    :class="{'p-invalid' : errors.spesifikasi_pekerjaan}" 
                                                    :value="initialform.paket_pengadaan.spesifikasi_pekerjaan"
                                                />
                                            </div>
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="metode_pemilihan" value="Metode Pemilihan" />
                                                <InputText 
                                                    class="w-3/4" 
                                                    id="metode_pemilihan" 
                                                    type="text"  
                                                    disabled="true"
                                                    :class="{'p-invalid' : errors.metode_pemilihan}" 
                                                    :value="initialform.paket_pengadaan.nama_metode_pemilihan"
                                                />
                                            </div>
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="jadwal_mulai_pemilihan_penyedia" value="Jadwal Mulai Pemilihan Penyedia" />
                                                <InputText 
                                                    class="w-3/4" 
                                                    id="jadwal_mulai_pemilihan_penyedia" 
                                                    type="text"  
                                                    disabled="true"
                                                    :class="{'p-invalid' : errors.jadwal_mulai_pemilihan_penyedia}" 
                                                    :value="initialform.paket_pengadaan.jadwal_mulai_pemilihan_penyedia"
                                                />
                                            </div>
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="jadwal_selesai_pemilihan_penyedia" value="Jadwal Selesai Pemilihan Penyedia" />
                                                <InputText 
                                                    class="w-3/4" 
                                                    id="jadwal_selesai_pemilihan_penyedia" 
                                                    type="text"  
                                                    disabled="true"
                                                    :class="{'p-invalid' : errors.jadwal_selesai_pemilihan_penyedia}" 
                                                    :value="initialform.paket_pengadaan.jadwal_selesai_pemilihan_penyedia"
                                                />
                                            </div>
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="id_proposal_urp" value="ID Proposal URP" />
                                                <InputText 
                                                    class="w-3/4" 
                                                    id="id_proposal_urp" 
                                                    type="text"  
                                                    disabled="true"
                                                    :class="{'p-invalid' : errors.id_proposal_urp}" 
                                                    :value="initialform.paket_pengadaan.id_proposal_urp"
                                                />
                                            </div>
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="unit" value="Unit" />
                                                <InputText 
                                                    class="w-3/4" 
                                                    id="unit" 
                                                    type="text"  
                                                    disabled="true"
                                                    :class="{'p-invalid' : errors.unit}" 
                                                    :value="initialform.paket_pengadaan.unit"
                                                />
                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <div v-if="pengadaan_langsung">
                                        <AccordionTab>
                                            <template #header>
                                                <span class="flex align-items-center gap-2 w-full">
                                                    <span class="font-bold white-space-nowrap">Organisasi Pengadaan (Pengadaan Langsung)</span>
                                                </span>
                                            </template>
                                            <div class="p-4 lg:w-1/1 md:w-full">
                                                <div class="flex items-center gap-2">
                                                    <JetLabel class="w-1/4 my-2" for="ppk" value="Pejabat Pembuat Komitmen" />
                                                    <InputText 
                                                        class="w-3/4" 
                                                        id="ppk" 
                                                        type="text"  
                                                        disabled="true"
                                                        :class="{'p-invalid' : errors.ppk}" 
                                                        v-model="form.ppk" 
                                                    />
                                                    <small v-if="errors.ppk" id="name-help" class="p-error">PPK Wajib Diisi</small>
                                                </div>
                                            </div>
                                            <div class="p-4 lg:w-1/1 md:w-full">
                                                <div class="flex items-center gap-2">
                                                    <JetLabel class="w-1/4 my-2" for="pp" value="Pejabat Pengadaan" />
                                                    <InputText 
                                                        class="w-3/4" 
                                                        id="pp" 
                                                        type="text"  
                                                        disabled="true"
                                                        :class="{'p-invalid' : errors.pp}" 
                                                        v-model="form.pp"
                                                    />
                                                    <small v-if="errors.pp" id="name-help" class="p-error">PP Wajib Diisi</small>
                                                </div>
                                            </div>
                                            <div class="p-4 lg:w-1/1 md:w-full">
                                                <div class="flex items-center gap-2">
                                                    <JetLabel class="w-1/4 my-2" for="pphp" value="Pejabat Penerima Hasil Pekerjaan" />
                                                    <InputText 
                                                        class="w-3/4" 
                                                        id="pphp" 
                                                        type="text"  
                                                        disabled="true"
                                                        :class="{'p-invalid' : errors.pphp}" 
                                                        v-model="form.pphp" 
                                                    />
                                                    <small v-if="errors.pphp" id="name-help" class="p-error">PPHP Wajib Diisi</small>
                                                </div>
                                            </div>
                                        </AccordionTab>
                                    </div>
                                    <div v-else>
                                        <AccordionTab>
                                            <template #header>
                                                <span class="flex align-items-center gap-2 w-full">
                                                    <span class="font-bold white-space-nowrap">Organisasi Pengadaan (Tender)</span>
                                                </span>
                                            </template>
                                            <div class="p-4 lg:w-1/1 md:w-full">
                                                <div class="flex items-center gap-2">
                                                    <JetLabel class="w-1/4 my-2" for="ppk_id" value="Pejabat Pembuat Komitmen" />
                                                    <InputText 
                                                        class="w-3/4" 
                                                        id="ppk" 
                                                        type="text"  
                                                        disabled="true"
                                                        :class="{'p-invalid' : errors.ppk}" 
                                                        v-model="form.ppk" 
                                                        :value="form.ppk"
                                                    />
                                                    <small v-if="errors.ppk_id" id="name-help" class="p-error">PPK Wajib Diisi</small>
                                                </div>
                                            </div>
                                        </AccordionTab>
                                        <AccordionTab v-if="adminkpbj">
                                            <template #header>
                                                <span class="flex align-items-center gap-2 w-full">
                                                    <span class="font-bold white-space-nowrap">POKJA (Tender)</span>
                                                </span>
                                            </template>
                                            <div class="p-5">
                                                <SelectPOKJA
                                                    v-model:list_pokja="form.pokja"
                                                />
                                            </div>
                                        </AccordionTab>
                                        <AccordionTab>
                                            <template #header>
                                                <span class="flex align-items-center gap-2 w-full">
                                                    <span class="font-bold white-space-nowrap">PPHP (Tender)</span>
                                                </span>
                                            </template>
                                            <div v-for="(pphp_tender, index) in initialform.pphp_tenderList" :key="pphp_tender.id" class="p-5">
                                                <InputText
                                                    class="w-3/4"
                                                    :id="'pphp_tender-' + pphp_tender.id" 
                                                    type="text"
                                                    disabled="true"
                                                    :class="{'p-invalid': errors.pphp_tender}"
                                                    v-model="pphp_tender.fullname"
                                                />
                                            </div>
                                        </AccordionTab>
                                    </div>
                                    <AccordionTab>
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Tim Teknis Perencanaan Pengadaan (Opsional)</span>
                                            </span>
                                        </template>
                                        <div v-for="(ttpp, index) in initialform.ttppList" :key="ttpp.id" class="p-5">
                                            <InputText
                                                class="w-3/4"
                                                :id="'ttpp-' + ttpp.id" 
                                                type="text"
                                                disabled="true"
                                                :class="{'p-invalid': errors.ttpp}"
                                                v-model="ttpp.fullname"
                                            />
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab>
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Tim Teknis Pelaksanaan Kontrak (Opsional)</span>
                                            </span>
                                        </template>
                                        <div v-for="(ttpk, index) in initialform.ttpkList" :key="ttpk.id" class="p-5">
                                            <InputText
                                                class="w-3/4"
                                                :id="'ttpk-' + ttpk.id" 
                                                type="text"
                                                disabled="true"
                                                :class="{'p-invalid': errors.ttpk}"
                                                v-model="ttpk.fullname"
                                            />
                                        </div>
                                    </AccordionTab>
                                </Accordion>
                            </div>
                            <div class="flex justify-end mt-5">
                                <!-- <Button 
                                    @click="submitForm(0)" 
                                    label="Save" 
                                    icon="pi pi-save" 
                                    :loading="isSubmitting"
                                    :disabled="isSubmitting"
                                    class="p-button-secondary mr-3"
                                /> -->
                                <Button 
                                    @click="submitForm(1)" 
                                    label="Submit" 
                                    icon="pi pi-check" 
                                    :loading="isSubmitting"
                                    :disabled="isSubmitting"
                                    class="p-button-success"
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
        <Toast />
    </app-layout>
</template>

<script>
import axios from 'axios'

import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import JetLabel from "@/Jetstream/Label";
import { Inertia } from '@inertiajs/inertia'
import { useForm } from "@inertiajs/inertia-vue3"
import AppMenuBar from "@/Components/AppMenuBar.vue";
import DeleteDialog from "@/Components/DeleteDialog";
import DropdownWilayah from "@/Components/DropdownWilayah.vue";
import MapInput from "@/Components/MapInput.vue";
import { FilterMatchMode } from "primevue/api";
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import AutoComplete from 'primevue/autocomplete';
import Button from "primevue/button";
import Calendar from 'primevue/calendar';
import Card from "primevue/card";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import Dialog from 'primevue/dialog';
import Divider from "primevue/divider";
import Dropdown from 'primevue/dropdown';
import FileUpload from 'primevue/fileupload';
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import Menubar from "primevue/menubar";
import MultiSelect from 'primevue/multiselect';
import OverlayPanel from 'primevue/overlaypanel';
import Password from "primevue/password";
import ProgressBar from 'primevue/progressbar';
import RadioButton from 'primevue/radiobutton';
import Textarea from 'primevue/textarea';
import pdfvuer from 'pdfvuer'
import SelectPOKJA from "./partials/SelectPOKJA.vue";
import SelectPPHPTender from "./partials/SelectPPHPTender.vue";
import SelectTTPP from "./partials/SelectTTPP.vue";
import SelectTTPK from "./partials/SelectTTPK.vue";
import Toast from 'primevue/toast';

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppMenuBar,
        JetLabel,
        DeleteDialog,
        DropdownWilayah,
        MapInput,
        Accordion,
        AccordionTab,
        AutoComplete,
        Button,
        Calendar,
        Card,
        Column,
        DataTable,
        Dialog,
        Divider,
        Dropdown,
        FileUpload,
        InputText,
        InputNumber,
        Menubar,
        MultiSelect,
        OverlayPanel,
        Password,
        ProgressBar,
        RadioButton,
        Textarea,
        pdf: pdfvuer,
        SelectPOKJA,
        SelectPPHPTender,
        SelectTTPP,
        SelectTTPK,
        Toast,
    },
    props : {
        errors : Array,
        initialform : Object,
        pengadaan_langsung : Boolean,
        adminkpbj : Boolean,
        organisasi_pengadaan : Array,
        paket_pengadaan : Object,
        daftar_pokja : Array,
        nama_ppk : String,
        nama_pp : String,
        nama_pphp : String,
        daftar_ppk : Array,
        daftar_pp : Array,
        daftar_pphp : Array,
        daftar_ttpp : Array,
        daftar_ttpk : Array,
    },
    data : function(){
        return {
            form : {
                name : '',
                permissions : [],
                menus : [],
                organisasi_pengadaan_id: this.initialform.id,
                paket_pengadaan_id: this.initialform.paket_pengadaan_id,
                pphp_tender: this.initialform.pphp_tender,
                pokja: [],
                ppk: this.initialform.ppk,
                pp: this.initialform.pp,
                pphp: this.initialform.pphp,
                ttpp: this.initialform.ttpp,
                ttpk: this.initialform.ttpk,
            },
            ppkOptions: [],
            ppOptions: [],
            pphpOptions: [],
            isSubmitting: false,
        }
    },
    mounted() {
        console.log("Props :", this.$props);
        console.log("Form :", this.form);
        // console.log("Boolean :", Boolean(this.pengadaan_langsung));
        this.fetchPPK({ value: "" });
        this.fetchPP({ value: "" });
        this.fetchPPHP({ value: "" });
    },
    methods : {
        async fetchPPK(event) {
            console.log("Keyword : ", event.value);
            try {
                const response = await axios.post(
                    "/organisasi_pengadaan/search_ppk",
                    {
                        params: {
                            keyword: event.value || "",
                        },
                    }
                );
                if (response.data && Array.isArray(response.data)) {
                    this.ppkOptions = response.data;
                }
            } catch (error) {
                console.error("Error fetching ppk:", error);
            }
        },
        async fetchPP(event) {
            console.log("Keyword : ", event.value);
            try {
                const response = await axios.post(
                    "/organisasi_pengadaan/search_pp",
                    {
                        params: {
                            keyword: event.value || "",
                        },
                    }
                );
                if (response.data && Array.isArray(response.data)) {
                    this.ppOptions = response.data;
                }
            } catch (error) {
                console.error("Error fetching pp:", error);
            }
        },
        async fetchPPHP(event) {
            console.log("Keyword : ", event.value);
            try {
                const response = await axios.post(
                    "/organisasi_pengadaan/search_pphp",
                    {
                        params: {
                            keyword: event.value || "",
                        },
                    }
                );
                if (response.data && Array.isArray(response.data)) {
                    this.pphpOptions = response.data;
                }
            } catch (error) {
                console.error("Error fetching pphp:", error);
            }
        },
        submitForm(v){
            if (this.isSubmitting) return; // Prevent double submission
            
            this.isSubmitting = true;
            this.form.button = v;
            
            Inertia.post(route('organisasi_pengadaan.store_pokja'), this.form, {
                onSuccess: () => {
                    this.isSubmitting = false;
                    // Success handled by redirect in controller
                },
                onError: (errors) => {
                    this.isSubmitting = false;
                    console.error('POKJA submission failed:', errors);
                    // Show error message to user
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Gagal menyimpan data POKJA. Silakan coba lagi.',
                        life: 3000
                    });
                },
                onFinish: () => {
                    this.isSubmitting = false;
                }
            });
        }
    }
}
</script>
